import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./video-modal.scss";
import Modal from "components/modal/Modal";
import StorylaneVideo from "components/products/StorylaneVideo";

interface Props {
    isOpen: boolean;
    hideModal: () => void;
    linkUrl: string;
    className?: string;
}

export const VideoModal = (props: Props) => {
    const { t } = useTranslation();
    return (
        <Modal
            isOpen={props.isOpen}
            hideModal={() => props.hideModal()}
            className={classNames(style.videoModalBase, props.className)}
            isVideoPopup
            modalTitle={
                props.linkUrl === "https://blancco.storylane.io/share/bmp-gettingstarted"
                    ? undefined
                    : t("Onboarding.home.watchTutorial")
            }
        >
            <StorylaneVideo linkUrl={props.linkUrl} />
        </Modal>
    );
};
